import DOMPurify from 'dompurify';

export default function PurifyHTML(html) {
    return DOMPurify.sanitize(html);
}